import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Grid, FormControlLabel, Switch } from "@material-ui/core";
import CohortGraph from "react-cohort-graph";
import { useCohortAnalysis } from "../hooks/useCohortAnalysis";
import { FormSelect } from "../../summary/components/FormSelect";
import { LoadingSpinner } from "../../summary/components/LoadingSpinner";
import {
  PRODUCT_TYPE_OPTIONS,
  SUBSCRIPTION_TYPE_OPTIONS,
} from "../../summary/constants/cohortOptions";
import { listOfSubscriptions } from "../../../common/envConfig";

function CohortAnalysisComponent({ subscriptions }) {
  const [productType, setProductType] = useState(listOfSubscriptions.PREMIUM);
  const [subType, setSubType] = useState("all");
  const [infantChurn, setInfantChurn] = useState(true);

  const { data, loading } = useCohortAnalysis({
    subscriptions,
    productType,
    subType,
    infantChurn,
  });

  const handleProductType = (e) => {
    setProductType(e.target.value);
  };

  const handleSubType = (e) => {
    setSubType(e.target.value);
  };

  const handleInfantChurn = (checked) => {
    setInfantChurn(checked);
  };

  return (
    <>
      <Container component="main" style={{ padding: "20px 0" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormSelect
              label="Product Type"
              labelId="product-type-select"
              value={productType}
              onChange={handleProductType}
              options={PRODUCT_TYPE_OPTIONS}
            />
          </Grid>
          <Grid item xs={6}>
            <FormSelect
              label="Subscription Type"
              labelId="subscription-type-select"
              value={subType}
              onChange={handleSubType}
              options={SUBSCRIPTION_TYPE_OPTIONS}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={infantChurn}
                  onChange={(event) => handleInfantChurn(event.target.checked)}
                  color="primary"
                />
              }
              label="Remove Infant Churn"
              labelPlacement="start"
            />
          </Grid>
          <Grid item xs={12}>
            {Object.keys(data).length > 0 && (
              <CohortGraph
                data={data}
                dataType="months"
                defaultValueType={["percent"]}
                keyCellColor="#fff"
                headerCellColor="#ccc"
                bodyCellColor="#eee"
                headerCellStyles={{
                  color: "black",
                }}
                bodyCellStyles={{
                  color: "black",
                }}
                tableCellStyles={{
                  color: "black",
                }}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            <LoadingSpinner show={loading} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

CohortAnalysisComponent.propTypes = {
  subscriptions: PropTypes.array,
};

export const CohortAnalysis = CohortAnalysisComponent;
